import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';

/**
 * La schermata con cui il portale si apre, finche' la prima pagina non e' pronta: il logo, fermo come
 * ovunque, sopra una rotellina. Prende il posto di quella statica di `index.html` — stessa forma, stessa
 * misura — cosi' fra il primo disegno del browser e la prima pagina non c'e' uno stacco da notare.
 */
@Component({
  selector: 'dxp-splash-screen',
  standalone: true,
  templateUrl: './splash-screen.component.html',
  styleUrl: './splash-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SplashScreenComponent {
  /** Il nome del portale: e' come si chiama il logo per chi non lo vede. */
  @Input({ required: true }) brandName!: string;

  /** Cosa sta succedendo, per chi non vede l'animazione: e' il nome della regione occupata. */
  @Input({ required: true }) label!: string;

  /**
   * Il logo del tenant per il tema dipinto, o `null` per il disegno del portale. Un indirizzo nuovo — il
   * tema che cambia — si riprova anche se il precedente non si era caricato.
   */
  @Input()
  set logoUrl(url: string | null) {
    this._logoUrl = url;
    this.logoLoaded.set(false);
    this.logoFailed.set(false);
  }
  get logoUrl(): string | null {
    return this._logoUrl;
  }
  private _logoUrl: string | null = null;

  /**
   * Il logo del tenant e' arrivato: finche' non arriva il suo posto resta vuoto, invece di mostrare
   * l'immagine a pezzi mentre scende.
   */
  protected readonly logoLoaded = signal(false);

  /** Il logo del tenant non si e' caricato: torna il disegno del portale, che c'e' sempre. */
  protected readonly logoFailed = signal(false);
}
